var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0",
        y: "0",
        viewBox: "0 0 50 50",
        "xml:space": "preserve",
      },
    },
    [
      _c("path", {
        style: "fill: " + _vm.setFillColors.inner,
        attrs: {
          d: "M35.49 37.93H14.51c-1.71 0-3.1-1.39-3.1-3.1V21.09c0-.23.18-.41.41-.41h26.34c.23 0 .41.18.41.41v13.74c.01 1.71-1.38 3.1-3.08 3.1zM12.24 21.5v13.33c0 1.25 1.02 2.27 2.27 2.27h20.97c1.25 0 2.27-1.02 2.27-2.27V21.5H12.24z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        style: "fill: " + _vm.setFillColors.inner,
        attrs: {
          d: "M38.17 21.5H11.83c-.23 0-.41-.18-.41-.41v-3.41c0-1.71 1.39-3.1 3.1-3.1h20.97c1.71 0 3.09 1.39 3.09 3.1v3.41c0 .23-.18.41-.41.41zm-25.93-.82h25.52v-3c0-1.25-1.02-2.27-2.27-2.27H14.51c-1.25 0-2.27 1.02-2.27 2.27v3z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        style: "fill: " + _vm.setFillColors.inner,
        attrs: {
          d: "M17.43 17.92h-1.92c-.23 0-.41-.18-.41-.41v-5.02c0-.23.18-.41.41-.41h1.92c.23 0 .41.18.41.41v.69c0 .23-.18.41-.41.41-.23 0-.41-.18-.41-.41v-.28h-1.1v4.2h1.1v-.28c0-.23.18-.41.41-.41.23 0 .41.18.41.41v.69c0 .22-.18.41-.41.41zM21.7 17.92h-1.92c-.23 0-.41-.18-.41-.41v-5.02c0-.23.18-.41.41-.41h1.92c.23 0 .41.18.41.41v.69c0 .23-.18.41-.41.41-.23 0-.41-.18-.41-.41v-.28h-1.1v4.2h1.1v-.28c0-.23.18-.41.41-.41.23 0 .41.18.41.41v.69c0 .22-.19.41-.41.41zM25.96 17.92h-1.92c-.23 0-.41-.18-.41-.41v-5.02c0-.23.18-.41.41-.41h1.92c.23 0 .41.18.41.41v.69c0 .23-.18.41-.41.41-.23 0-.41-.18-.41-.41v-.28h-1.1v4.2h1.1v-.28c0-.23.18-.41.41-.41.23 0 .41.18.41.41v.69c0 .22-.18.41-.41.41zM30.23 17.92H28.3c-.23 0-.41-.18-.41-.41v-5.02c0-.23.18-.41.41-.41h1.92c.23 0 .41.18.41.41v.69c0 .23-.18.41-.41.41-.23 0-.41-.18-.41-.41v-.28h-1.1v4.2h1.1v-.28c0-.23.18-.41.41-.41.23 0 .41.18.41.41v.69c.01.22-.18.41-.4.41zM34.49 17.92h-1.92c-.23 0-.41-.18-.41-.41v-5.02c0-.23.18-.41.41-.41h1.92c.23 0 .41.18.41.41v.69c0 .23-.18.41-.41.41-.23 0-.41-.18-.41-.41v-.28h-1.1v4.2h1.1v-.28c0-.23.18-.41.41-.41.23 0 .41.18.41.41v.69c.01.22-.18.41-.41.41zM25 34.7c-2.93 0-5.31-2.38-5.31-5.31 0-2.93 2.38-5.31 5.31-5.31 2.93 0 5.31 2.38 5.31 5.31 0 2.93-2.38 5.31-5.31 5.31zm0-9.79c-2.47 0-4.48 2.01-4.48 4.48 0 2.47 2.01 4.48 4.48 4.48 2.47 0 4.48-2.01 4.48-4.48 0-2.47-2.01-4.48-4.48-4.48z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        style: "fill: " + _vm.setFillColors.inner,
        attrs: {
          d: "M25 29.81a.4.4 0 0 1-.29-.12l-1.27-1.27a.41.41 0 0 1 .58-.58l.98.97 1.97-1.97a.41.41 0 0 1 .58.58l-2.26 2.26a.41.41 0 0 1-.29.13zM29.26 27.24a.41.41 0 0 1-.29-.7l.74-.74-1.01-1.06-.79.74a.41.41 0 0 1-.58-.58l.74-.74c.34-.33.88-.34 1.22 0l1.01 1.01c.34.34.34.88 0 1.22l-.74.74c-.09.07-.19.11-.3.11zM20.74 27.24a.4.4 0 0 1-.29-.12l-.74-.74a.857.857 0 0 1 0-1.22l1.01-1.01c.34-.34.88-.34 1.22 0l.74.74a.41.41 0 0 1-.58.58l-.74-.74-1.06 1.01.74.79c.16.16.16.42 0 .58a.41.41 0 0 1-.3.13z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        style: "fill: " + _vm.setFillColors.outer,
        attrs: {
          d: "M25 49C11.77 49 1 38.23 1 25S11.77 1 25 1s24 10.77 24 24-10.77 24-24 24zm0-46.55C12.57 2.45 2.45 12.57 2.45 25c0 12.43 10.11 22.55 22.55 22.55S47.55 37.43 47.55 25C47.55 12.57 37.43 2.45 25 2.45z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }